import { z } from 'zod';
import { postRequest } from './amplify/helpers';
import { upload } from './s3';
import { v4 as uuidv4 } from 'uuid';

export enum TempFileContext {
  PERSONAL_AVATAR = 'PERSONAL_AVATAR',
  DEFAULT = 'DEFAULT',
}
export const UserUploadedFileSchema = z.object({
  s3Key: z.string(),
  isTemp: z.boolean().optional(),
  publicUrl: z.string().optional(),
  fileName: z.string().optional(),
  fileType: z.string().optional(),
});
export type UserUploadedFile = z.infer<typeof UserUploadedFileSchema>;

export type UploadedTempFile = UserUploadedFile;

const UploadFileSchema = z.object({
  appKey: z.string(),
  fileName: z.string(),
  context: z.nativeEnum(TempFileContext).optional(),
});
export const getPresignedUrl = async (
  request: z.infer<typeof UploadFileSchema>
): Promise<{ uploadUrl: string; s3Key: string; publicUrl: string }> => {
  return await postRequest({
    apiName: 'studio',
    path: '/temp-file-upload/presigned-url',
    options: {
      body: request,
    },
  });
};

export const uploadTempFileToS3 = async ({
  appKey,
  fileName,
  file,
  context,
  progressCallback,
}: {
  appKey: string;
  fileName: string;
  file: File;
  context?: TempFileContext;
  progressCallback?: (progress: number) => void;
}): Promise<UserUploadedFile> => {
  const uuid = uuidv4();
  const { uploadUrl, s3Key, publicUrl } = await getPresignedUrl({
    appKey,
    fileName: `${uuid}-${fileName}`,
    context,
  });

  await upload(uploadUrl, file, progressCallback);

  return { s3Key, publicUrl, fileName, fileType: file.type, isTemp: true };
};
